var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lottie",staticStyle:{"background":"#b3b3b3"}},[_c('Animation',{staticStyle:{"height":"100vh"},attrs:{"src":'assets/animation/404.json',"loop":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }